var ServiceOtherLabels = {
  CATALOG: "Catalog",
  VOLUMES: "Volumes",
  PODS: "Pods"
};

module.exports = ServiceOtherLabels;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/ServiceOtherLabels.js